module.exports = [
	{
		"start": 0.16,
		"text": "We came here on visitor's status because my dad knew that the refugee application would take a long time and he didn't want to risk our lives."
	},
	{
		"start": 10.29,
		"text": "I think I was 7 or 8 at the time. There were guerrillas that basically wanted to do a coup d'etat in Togo."
	},
	{
		"start": 17.58,
		"text": "So, our house was right at the border of Togo and Ghana. When they were coming in, they killed everybody in that area."
	},
	{
		"start": 26.619,
		"text": "And when they came to our house, they told my mom: \"Look, we're going to spare your life. Leave with your children now, and don't come back.\""
	},
	{
		"start": 35.98,
		"text": "I spent most of my time in the libraries in Houston."
	},
	{
		"start": 40.52,
		"text": "One particular library, the Harris County Public Library, is where I learned English because I found peace in reading books."
	},
	{
		"start": 49.48,
		"text": "I found friendship in reading books. So I studied political science and international relations in college."
	},
	{
		"start": 60.08,
		"text": "And when I got DACA, I was actually at [the University of Houston] taking my master's program."
	},
	{
		"start": 68.4,
		"text": "And then, because of DACA, I was able to work and pay my way through my doctorate degree."
	},
	{
		"start": 76.02,
		"text": "It's really tough to have an education and not be able to do anything with your education."
	},
	{
		"start": 83.24,
		"text": "And so that had been bearing down on me for a while. So receiving DACA, I felt as if I had been liberated, to an extent, from shackles."
	},
	{
		"start": 94.88,
		"text": "So it was really amazing."
	},
	{
		"start": 98.52,
		"text": "So now that there is the possibility that DACA will be taken away, it makes me feel like"
	},
	{
		"start": 105.02,
		"text": "I have to go back to the drawing board again. Because I have to figure out what I need to do again to survive."
	},
	{
		"start": 114.24,
		"text": "I'm not mad. Because I've studied politics, so I know that in politics you need to make deals."
	},
	{
		"start": 122.6,
		"text": "I completely understand what's going on, but at the same time, it doesn't mean that it's fair."
	}
];


//////////////////
// WEBPACK FOOTER
// ../assets/transcripts/nancy.json
// module id = 10
// module chunks = 0